import React, { FunctionComponent, Fragment } from 'react';
import Card from '../../Common/Card/Card';

export type Props = {
	mode?: string;
	children: JSX.Element;
};

const Products: FunctionComponent<Props> = ({ children, mode }) => (
	<Card mode={mode} label="Financial Planning Software">
		{children}
	</Card>
);

export default Products;
